'use strict';

var $ = require('jquery');
var Animation = require('../lib/Animation.js');
var AnimationEasing = require('../lib/AnimationEasing.js');
var Range = require('../lib/Range.js');

function init() {
	var $searchArea = $('.searchArea');
	var $searchIcon = $('.searchArea__icon');
	
	$searchArea.find('input').keypress(function(event){
		var input = $(this);
		if (event.keyCode === 13) {
			var submitButtons = input.closest('form').find(':submit:first, input.submit:first, input[type="image"]:first');
			if ( submitButtons.length > 0 ) {
				// handle the submit
				submitButtons.first().click();
				return false;
			}
			return true;
		}
	});
	
	$searchIcon.on('click', function(){
		$searchArea.toggleClass('open');
		if ( $searchArea.hasClass('open') ){
			$searchArea.find('.searchArea__input').focus();
		}
	});
}

module.exports = {
	init : init
};
